import pxToRem from "../../functions/pxToRem";
import rgba from "../../functions/rgba";

export default function menuItem({ colors, borders, typography }) {
  const { text, info, grey } = colors;
  const { borderRadius } = borders;
  const { size, fontWeightMedium } = typography;

  const menuItem = {
    styleOverrides: {
      root: {
        minWidth: pxToRem(160),
        minHeight: "unset",
        padding: `${pxToRem(10)} ${pxToRem(14)}`,
        borderRadius: borderRadius.md,
        fontSize: size.sm,
        color: grey[700],
        fontWeight: fontWeightMedium,
        transition: "background-color 150ms ease-in-out, color 150ms ease-in-out",
        margin: `${pxToRem(2)} ${pxToRem(4)}`,

        "&:hover": {
          backgroundColor: grey[100],
          color: text.primary,
        },

        "&:focus": {
          backgroundColor: grey[100],
          color: text.primary,
        },

        "&.Mui-selected": {
          backgroundColor: rgba(info.main, 0.08),
          color: info.main,
          fontWeight: 600,

          "&:hover": {
            backgroundColor: rgba(info.main, 0.12),
          },

          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            width: pxToRem(3),
            height: "60%",
            backgroundColor: info.main,
            borderRadius: pxToRem(2),
          },
        },

        // Add divider between items if needed
        "&:not(:last-child)": {
          marginBottom: pxToRem(1),
        },
      },
    },
  };

  return menuItem;
}
